import ApiClient from ".."

// Out DTOs
import CalendarGetGroupCoachingLinksOut from "../../dtos/out/CalendarGetGroupCoachingLinksOut"

export class CalendarEndpoints {
  constructor(private client: ApiClient) {}
  static readonly BASE_URL = "/calendar"

  /**
   * Retrieves the group coaching links for a user.
   */
  async getGroupCoachingLinks(userId: number) {
    return this.client.get<CalendarGetGroupCoachingLinksOut>(
      CalendarEndpoints.BASE_URL,
      `/group-coaching/user/${userId}`
    )
  }
}
